import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { Get, Post, Put } from "../../../api";
import {
  UpdateCountryOptionsAction,
  UpdateFetchedIconUrlAction,
  UpdateGenderOptionsAction,
  UpdateOSOptionsAction,
  UpdatePersistCampaignRequestStateAction,
  UpdateCampaignDetailsAction,
  UpdateFetchCampaignRequestStateAction,
} from "./action";
import { TransformOptionResponse } from "./transformer";
import {
  RequestFailedUpdate,
  RequestLoadingUpdate,
  RequestSuccessfulUpdate,
} from "../../../request";
import { CampaignDetails } from "../default/reducer";

export function* cpaCampaignDetailsSaga() {
  yield takeEvery("cpa-campaign-details-validate-app", validateApp);
  yield takeLatest("cpa-campaign-details-persist", persistCampaign);
  yield takeEvery("cpa-campaign-details-fetch-os-options", fetchOSOptions);
  yield takeEvery("cpa-campaign-details-fetch-gender-options", fetchGenderOptions);
  yield takeEvery(
    "cpa-campaign-details-fetch-country-options",
    fetchCountryOptions
  );
  yield takeEvery("cpa-campaign-details-fetch-campaign", fetchCampaignDetails);
}

function* validateApp(action: any) {
  try {
    // @ts-ignore
    const response = yield call(Post, "/dashboard/validate/app", {
      playStoreUrl: action.playStoreUrl,
    });
    yield put(UpdateFetchedIconUrlAction(response.iconUrl));
  } catch (e) {}
}

function* persistCampaign(action: any) {
  try {
    yield put(UpdatePersistCampaignRequestStateAction(RequestLoadingUpdate));
    const campaignId = action.campaign.id;

    const response = !campaignId
      ? // @ts-ignore
        yield call(Post, `/dashboard/campaigns`, action.campaign)
      : // @ts-ignore
        yield call(Put, `/dashboard/campaigns/${campaignId}`, action.campaign);
    yield put(UpdateFetchedIconUrlAction(response.iconUrl));

    yield put(UpdatePersistCampaignRequestStateAction(RequestSuccessfulUpdate));
  } catch (e) {
    yield put(UpdatePersistCampaignRequestStateAction(RequestFailedUpdate));
  }
}

function* fetchOSOptions(action: any) {
  try {
    // @ts-ignore
    const response = yield call(Get, "/dashboard/options/os");
    yield put(UpdateOSOptionsAction(TransformOptionResponse(response)));
  } catch (e) {}
}

function* fetchCountryOptions(action: any) {
  try {
    // @ts-ignore
    const response = yield call(Get, "/dashboard/options/country");
    yield put(UpdateCountryOptionsAction(TransformOptionResponse(response)));
  } catch (e) {}
}

function* fetchGenderOptions(action: any) {
  try {
    // @ts-ignore
    const response = yield call(Get, "/dashboard/options/gender");
    yield put(UpdateGenderOptionsAction(TransformOptionResponse(response)));
  } catch (e) {}
}

function* fetchCampaignDetails(action: any) {
  try {
    yield put(UpdateFetchCampaignRequestStateAction(RequestLoadingUpdate));

    // @ts-ignore
    const response = yield call(
      Get,
      `/dashboard/campaigns/${action.campaignId}/details`
    );

    const campaignDetails: CampaignDetails & { isDirect: boolean } = {
      id: action.campaignId,
      name: response.name || "",
      iconUrl: response.iconUrl || "",
      mmp: response.clickUrl?.includes("adjust")
        ? "adjust"
        : response.clickUrl?.includes(".sng.link")
        ? "singular"
        : response.clickUrl?.includes("tenjin")
        ? "tenjin"
        : "appsflyer",
      playStoreUrl: response.playStoreUrl || "",
      countries: Array.isArray(response.countries) ? response.countries : null,
      genders: Array.isArray(response.genders) ? response.genders : null,
      minAge: response.minAge,
      maxAge: response.maxAge,
      minApiLevel: response.minApiLevel,
      maxApiLevel: response.maxApiLevel,
      bid: response.bid || 0,
      biddingType: response.biddingType || "cpa",
      dailyBudgetCap: response.dailyBudgetCap || 0,
      clickUrl: response.clickUrl || "",
      platform: response.platform === "web" ? "android" : response.platform || "android",
      appStoreUrl: response.appStoreUrl || "",
      biddingEvent: response.biddingEvent,
      isDirect: response.isDirect ?? true,
    };

    yield put(UpdateCampaignDetailsAction(campaignDetails));
    yield put(UpdateFetchCampaignRequestStateAction(RequestSuccessfulUpdate));
  } catch (e) {
    yield put(UpdateFetchCampaignRequestStateAction(RequestFailedUpdate));
  }
}
